import React from "react";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";

import dayjs from "dayjs";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
import { useEffect } from "react";
import swal from "sweetalert";

import {
  makeGetRequest,
  makePostRequest
} from "../../../utils/utils";

function AssignDuty() {
  const navigate = useNavigate();

  const [value, setValue] = React.useState(dayjs("2014-08-18T21:11:54"));
  const [q] = React.useState("");

  const handleChange = (newValue) => {
    setValue(newValue);
    console.log('Selected Value');
    console.log(value);
  };

  const [guardsList, setGuardsList] = React.useState([]);
  const [selectedGuard, setSelectedGuard] = React.useState('');
  const [spotList, setSpotList] = React.useState([]);
  const [selectedSpot, setSelectedSpot] = React.useState('');

  async function GuardsListing() {
    let bodyFormData = {};

    makePostRequest(
      "guards/guardlisting?searchq=&pageNo=1&count=10",
      bodyFormData
    )
      .then((response) => {
        if (response.status == "201") {
          console.log("Guards Data");
          console.log(response.data.data.rows);
          //setlength(response.data.data.rowCount);
          const data = response.data.data.rows;
          setGuardsList(data);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  async function SpotListing() {
    let bodyFormData = "";

    makeGetRequest("spot/getalllist", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log(response.data.data)
          setSpotList(response.data.data);

        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  const handlechangeGuard = (e) => {
    alert(e.target.value)
    setSelectedGuard(e.target.value);
    SpotListing();
  }

  const handlechangeSpot = (e) => {
    alert(e.target.value)
    setSelectedSpot(e.target.value);
  }

  useEffect(() => {
    GuardsListing();
  }, [q]);


  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">Assign Duty</h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            {/* <div className="residentHeading">Add Spot</div> */}
            <div className="addSocietyMain">
              <div className="addSocietyInnerMain" style={{ marginTop: 15 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <select
                      className="inputSt"
                      value={selectedGuard}
                      onChange={handlechangeGuard}
                    >
                      <option value="" disabled>
                        Select Guard
                      </option>
                      {guardsList.map((option) => (
                        <option
                          key={option.guard_id}
                          value={option.guard_id}
                          data-isd={option.guard_name}
                        >
                          {option.guard_name}
                        </option>
                      ))}
                    </select>


                  </Grid>
                  <Grid item xs={12} md={6}>
                    <select
                      className="inputSt"
                      value={selectedSpot}
                      onChange={handlechangeSpot}
                    >
                      <option value="" disabled>
                        Select Spot
                      </option>
                      {spotList.map((option) => (
                        <option
                          key={option.spot_id}
                          value={option.spot_id}
                          data-isd={option.spot_name}
                        >
                          {option.spot_name}
                        </option>
                      ))}
                    </select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="dateTimeMain">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack className="inputSt">
                          <DateTimePicker
                            value={value}
                            onChange={handleChange}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <div className="dateTimeMain">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Stack className="inputSt">
                          <DateTimePicker
                            value={value}
                            onChange={handleChange}
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </Stack>
                      </LocalizationProvider>
                    </div>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <Button className="addBt">Add</Button>
                  </Grid>

                  <Grid item xs={12} md={12}>
                    <div className="spotTailsOuter">
                      <div className="visitContDiv">
                        <div className="visitCont1 resideNewContOut">
                          <div className="visitContProf">
                            <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" />
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed">Lorem Ipsum</h3>
                            <p className="visitContMob">(225) 555-0118</p>
                            <p className="visitContTime">
                              jessica.hanson@example.com
                            </p>
                          </div>
                          <div className="visitBottCont">
                            <p>Wing/Flat Number</p>
                            <b>Wing A - 922</b>
                          </div>
                          <div className="visitBottCont">
                            <p>Committy Designation</p>
                            <b>Secretory</b>
                          </div>
                          <div className="resideNewCont">
                            <CreateIcon
                              className="editBt"
                              onClick={() => navigate("")}
                            />
                            <DeleteIcon className="deleteBt" />
                          </div>
                        </div>
                      </div>

                      <div className="visitContDiv">
                        <div className="visitCont1 resideNewContOut">
                          <div className="visitContProf">
                            <img src="https://d2qp0siotla746.cloudfront.net/img/use-cases/profile-picture/template_3.jpg" />
                          </div>
                          <div className="visitContLeft">
                            <h3 className="visitContHed">Lorem Ipsum</h3>
                            <p className="visitContMob">(225) 555-0118</p>
                            <p className="visitContTime">
                              jessica.hanson@example.com
                            </p>
                          </div>
                          <div className="visitBottCont">
                            <p>Wing/Flat Number</p>
                            <b>Wing A - 922</b>
                          </div>
                          <div className="visitBottCont">
                            <p>Committy Designation</p>
                            <b>Secretory</b>
                          </div>
                          <div className="resideNewCont">
                            <CreateIcon
                              className="editBt"
                              onClick={() => navigate("")}
                            />
                            <DeleteIcon className="deleteBt" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default AssignDuty;
